import { HttpErrorResponse } from '@angular/common/http';
import { Component, Inject, ViewChild } from '@angular/core';
import { NgModel } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ToasterService } from 'src/app/Core/services/toaster.service';
import { UserService } from 'src/app/Core/services/user.service';

@Component({
  selector: 'app-subscription-defer',
  templateUrl: './subscription-defer.component.html',
  styleUrls: ['./subscription-defer.component.css']
})
export class SubscriptionDeferComponent {
  numberOfDeferDays: string | null = null;
  selectedDeferReason: number | null = null;
  enteredDeferDays: number | null = null;
  @ViewChild('daysInput') daysInput!: NgModel;
  biller: string | null = null
  userID: string | null = null

  constructor(@Inject(MAT_DIALOG_DATA) public data: { message: string, userID: string }, private userService: UserService, private toaster: ToasterService, public dialogRef: MatDialogRef<SubscriptionDeferComponent>,) {

  }

  ngOnInit(): void {
    this.biller = this.data.message;
    this.userID = this.data.userID;
  }

  isBillerApplePay() {
    return this.biller === "Apple Pay";
  }

  submitForm() {
    // Force the error message to show if user hasn't interacted
    this.daysInput.control.markAsTouched();
  }

  deferReasonChange(event: any) {
    this.selectedDeferReason = event.value;
  }

  deferSubscription() {
    console.log("selectedDeferReason", this.selectedDeferReason);
    console.log("enteredDeferDays", this.enteredDeferDays);
    console.log("userID", this.userID);

    const payload = {
      extend_by_days: Number(this.enteredDeferDays ?? 0),
      defer_reason: Number(this.selectedDeferReason ?? 0)
    };

    this.userService.deferSubscription(this.userID ?? "", payload).subscribe({
      next: (data: any) => {
        this.dialogRef.close();
      },

      error: (error) => {
        if (error instanceof HttpErrorResponse) {
          this.toaster.openDialogBox(error.error.message, false);
        }
      }
    });
  }

  enableDeferButton() {
    if (this.isBillerApplePay()) {
      return this.selectedDeferReason !== null && this.enteredDeferDays !== null && this.enteredDeferDays > 0 && this.enteredDeferDays <= 90;
    }
    return this.enteredDeferDays !== null && this.enteredDeferDays > 0 && this.enteredDeferDays <= 90;
  }

  validateDeferInput(event: KeyboardEvent) {
    const allowedKeys = /[0-9]/;
    if (!allowedKeys.test(event.key)) {
      event.preventDefault();
    }
  }
}
